import { createStore, applyMiddleware } from 'redux';
import thunnkMiddleware from 'redux-thunk';
import rootReducer from '../reducer/reducers.jsx';
// import logger from 'redux-logger'

const middleWareStore = applyMiddleware(thunnkMiddleware)(createStore);

export default function configureStore() {
    return middleWareStore(rootReducer);
}


// WEBPACK FOOTER //
// ./src/store/configurestore.jsx